export default __webpack_public_path__ + "static/roman-tymets-cbde34ec5bae9fe8a829cda4893c3bb1.png";